import { render, staticRenderFns } from "./ChatResourceOptions.vue?vue&type=template&id=71347348"
import script from "./ChatResourceOptions.vue?vue&type=script&lang=js"
export * from "./ChatResourceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports